import { Form } from '@rocketseat/unform';
import format from 'date-fns/format';
import produce from 'immer';
import React, { useEffect, useState } from 'react';
import { MdFileDownload, MdFilterList, MdSearch } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';

import {
  Breadcrumbs,
  Button,
  Dropdown,
  Modal,
  SearchBox,
  Text,
  Title,
  WrapperFlex,
} from '@unimed-fesp/components';

import history from '../../services/history';

import theme from '../../styles/theme';

import { Container } from './styles';

import modal from '../../context/TriggerModalContext';

import {
  ModalAlterarStatusRpa,
  ModalCancelarEnvioRpa,
} from '../../components/molecules/PartsModalListasRPA';

import FadeIn from '../../components/atoms/FadeIn';

import FilterExtends from '../../components/organisms/FilterExtends';
import TabTableListasRPA from '../../components/organisms/TabTableListasRPA';

import {
  MovimentacaoListaEnum,
  StatusListaRPAEnum,
  TipoListaEnum,
} from '../../enums';

import StatusListRpa from '../../components/molecules/StatusListRpa';
import { Creators as ListaActions } from '../../store/ducks/lista';
import { Creators as ModalidadeActions } from '../../store/ducks/modalidade';

function ListasRPA() {
  const dispatch = useDispatch();

  const { usuario } = useSelector((state) => state.auth);
  const { success, response } = useSelector((state) => state.modalidade);
  const { patchStatusRPA, patchListaEnvioRPA, getRelatorioRPA } = useSelector(
    (state) => state.lista
  );
  const ListasRPARedux = useSelector((state) => state.lista.getListasRPA);
  const { statusLists } = useSelector((state) => state.lista);
  const filterExtendsParams = {
    nomeLista: null,
    codigoContratante: null,
    nomeBeneficiario: null,
    cartaoBeneficiario: null,
    tipoLista: null,
    idTipoMovimentacao: null,
    codigoModalidade: null,
    codigoTermo: null,
    vencida: null,
    rn412: null,
    dataCriacaoDe: null,
    dataCriacaoAte: null,
    dataAtualizacaoDe: null,
    dataAtualizacaoAte: null,
  };

  const [relatorioRPAParams, setRelatorioRPAParams] = useState({
    codigoContratante: null,
    nomeBeneficiario: null,
    cartaoBeneficiario: null,
    tipoLista: null,
    idTipoMovimentacao: null,
    idStatus: 10,
    codigoModalidade: null,
    codigoTermo: null,
    dataCriacaoDe: null,
    dataCriacaoAte: null,
    dataAtualizacaoDe: null,
    dataAtualizacaoAte: null,
    nomeLista: null,
    nomeContratante: null,
    vencida: null,
    rn412: null,
    statusEnvioRpa: true,
    idStatusRpa: null,
  });

  const paginationTabParams = {
    pageNumber: 1,
    pageSize: 10,
  };

  const optionsButtonRPA = [
    {
      onClickOption: () => handleDropdownItemClick('Relatório resumido'),
      text: 'Relatório resumido',
    },
    {
      onClickOption: () => handleDropdownItemClick('Relatório detalhado'),
      text: 'Relatório detalhado',
    },
  ];
  const queryParamsDefault = {
    page_number: 0,
    page_size: 10,
    movement_list_filter: {
      is_admin: usuario.role === 'Adm',
      status: [],
      list_name: null,
      beneficiary_name_or_number_card: null,
      type_list: null,
      type_action: null,
      contractor_code: null,
      modality_code: null,
      term_code: null,
      expired: false,
      r_n412: false,
      file_name_movement: null,
      start_created_date: null,
      end_created_date: null,
      start_update_date: null,
      end_update_date: null,
    },
  };
  const [tipoStatusActive, setTipoStatusActive] = useState(0);
  const [openFilterExtends, setOpenFilterExtends] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [cancelFilterExtendsOpen, setCancelFilterExtendsOpen] = useState(false);
  const [filterParams, setFilterParams] = useState(filterExtendsParams);
  const [paginationParams, setPaginationParams] = useState(paginationTabParams);
  const [openModalSuccess, setOpenModalSuccess] = useState({
    success: false,
    message: '',
  });
  const [relatoriosLoading, setRelatoriosLoading] = useState({
    resumido: false,
    detalhado: false,
  });
  const [queryParams, setQueryParams] = useState(queryParamsDefault);

  const [searchBoxActive, setSearchBoxActive] = useState(false);
  const status = statusLists.response.actives
    .filter(({ id }) => id !== 0)
    .map(({ id }) => id);

  const paginationRequest = produce(paginationParams, (draft) => {
    draft.pageNumber = paginationParams.pageNumber - 1;
    draft.pageSize = paginationParams.pageSize;
  });

  function cleanFilterParams() {
    setFilterParams(filterExtendsParams);
  }

  function handleData(data) {
    const newFilterParams = produce(queryParams, (draft) => {
      draft.movement_list_filter.list_name = inputValue;
      draft.movement_list_filter.status = status;
      draft.movement_list_filter.contractor_code = data.codigoContratante;
      draft.movement_list_filter.beneficiary_name_or_number_card = hasChar(
        data.nomeBeneficiarioCartao
      )
        ? data.nomeBeneficiarioCartao
        : null;
      draft.movement_list_filter.type_list =
        data.tipo === 'Selecione o tipo'
          ? null
          : TipoListaEnum.returnId[data.tipo];
      draft.movement_list_filter.type_action =
        data.movimentacao === 'Selecione a movimentacao'
          ? null
          : MovimentacaoListaEnum.returnIdForNameFormatted[data.movimentacao];
      draft.movement_list_filter.modality_code =
        data.modalidade === 'Selecione a modalidade' ? null : data.modalidade;
      draft.movement_list_filter.term_code =
        data.termo === 'Selecione o termo' ? null : data.termo;
      draft.movement_list_filter.expired =
        data.vencida === 'Todas' ? null : data.vencida === 'Sim';
      draft.movement_list_filter.r_n412 =
        data.rn412 === 'Todas' ? null : data.rn412 === 'Sim';
      draft.movement_list_filter.start_created_date = data.dataCriacaoDe
        ? format(data.dataCriacaoDe, 'MM-dd-yyyy 00:00:00')
        : null;
      draft.movement_list_filter.end_created_date = data.dataCriacaoAte
        ? format(data.dataCriacaoAte, 'MM-dd-yyyy 23:59:59')
        : null;
      draft.movement_list_filter.start_update_date = data.dataAtualizacaoDe
        ? format(data.dataAtualizacaoDe, 'MM-dd-yyyy 00:00:00')
        : null;
      draft.movement_list_filter.end_update_date = data.dataAtualizacaoAte
        ? format(data.dataAtualizacaoAte, 'MM-dd-yyyy 23:59:59')
        : null;
    });

    const params = {
      ...newFilterParams,
      ...paginationRequest,
    };

    setFilterParams(newFilterParams);
    return params;
  }

  function handleRelatorioParams(filterParams) {
    const params = produce(filterParams, (draft) => {
      draft.pageNumber = null;
      draft.pageSize = null;
      draft.totalPages = null;
      draft.idStatusRpa =
        draft.tipoStatus === StatusListaRPAEnum.returnNameForTab.Todas
          ? null
          : draft.tipoStatus;
      draft.tipoStatus = null;
      draft.statusEnvioRpa = true;
    });

    return params;
  }

  function handleFilterExtends() {
    setOpenFilterExtends(!openFilterExtends);
  }

  function handleSubmit(data) {
    const params = handleData(data);
    const relatorioParams = handleRelatorioParams(params);

    // TODO trocar Action
    dispatch(ListaActions.postSearchListRpaRequest(params));

    /*  setRelatorioRPAParams(relatorioParams); */
    setCancelFilterExtendsOpen(false);
  }

  function handleModalidadesTermos() {
    dispatch(
      ModalidadeActions.getModalidadesRequest({
        codigoContratante: filterParams.codigoContratante,
      })
    );
  }

  function handleInputChange(e) {
    setInputValue(e.target.value);
  }

  function hasChar(string) {
    const matches = string.match(/[a-zA-Z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+/);
    if (matches != null) return true;
  }

  function handleInputKeyDown(e) {
    if (e.keyCode === 13) {
      if (status.length >= 1) {
        const newFilterParams = produce(queryParams, (draft) => {
          draft.movement_list_filter.status = status;
        });
        const params = {
          ...newFilterParams,
        };
        setPaginationParams(paginationTabParams);
        return dispatch(ListaActions.postSearchListRpaRequest(params));
      }

      if (e.target.value === '') {
        const totalStatus = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        const newFilterParams = produce(queryParams, (draft) => {
          draft.movement_list_filter.status = totalStatus;
          draft.movement_list_filter.list_name = null;
        });
        setQueryParams(newFilterParams);
        setSearchBoxActive(true);
        return dispatch(ListaActions.postSearchListRpaRequest(newFilterParams));
      }

      const newFilterParams = produce(queryParams, (draft) => {
        draft.movement_list_filter.list_name = e.target.value;
      });
      const params = {
        ...newFilterParams,
      };
      dispatch(ListaActions.postSearchListRpaRequest(params));
      setCancelFilterExtendsOpen(true);
      setSearchBoxActive(true);
      setQueryParams(newFilterParams);
    }
  }

  function handlePageChangeKeyDown(e) {
    const newFilterParams = produce(queryParams, (draft) => {
      draft.movement_list_filter.status = status;
    });
    if (e.keyCode === 13) {
      if (status.length < 1) {
        const params = {
          ...paginationRequest,
          ...queryParams,
        };
        return dispatch(ListaActions.postSearchListRpaRequest(params));
      }

      const params = {
        ...newFilterParams,
        ...paginationRequest,
      };

      if (paginationParams.pageNumber !== '')
        return dispatch(ListaActions.postSearchListRpaRequest(params));
    }
  }

  function handleChangeTab(nameTab) {
    const nameTabCapitalize = `${nameTab
      .charAt(0)
      .toUpperCase()}${nameTab.slice(1)}`;
    const { pageNumber, pageSize } = ListasRPARedux.response[nameTabCapitalize];
    setPaginationParams((oldParams) => ({
      ...oldParams,
      pageNumber,
      pageSize,
    }));
  }

  function handleChangePage(pagParams, tipoStatus) {
    const newPaginationParams = produce(pagParams, (draft) => {
      draft.pageNumber = pagParams.pageNumber - 1;
      draft.pageSize = pagParams.pageSize;
    });

    if (status.length < 1) {
      const params = {
        ...queryParams,
        ...newPaginationParams,
      };

      return dispatch(ListaActions.postSearchListRpaRequest(params));
    }

    const newFilterParams = produce(queryParams, (draft) => {
      draft.movement_list_filter.status = status;
    });

    const params = {
      ...newFilterParams,
      ...newPaginationParams,
    };

    return dispatch(ListaActions.postSearchListRpaRequest(params));
    /* 
    const params = {
      ...filterParams,
      ...pagParams,
      tipoStatus,
    };

    if (tipoStatusActive !== tipoStatus) {
      setTipoStatusActive(tipoStatus);
    }

    dispatch(ListaActions.getListasRPAPorStatusRequest(params)); */
  }

  function handleGetModalidadesByContratante(e, codigoContratante) {
    e.stopPropagation();
    if (e.keyCode === 13) e.preventDefault();

    if (
      codigoContratante &&
      filterParams.codigoContratante !== codigoContratante
    ) {
      const newFilterParams = produce(filterParams, (draft) => {
        draft.codigoContratante = codigoContratante;
      });

      setFilterParams(newFilterParams);
      dispatch(
        ModalidadeActions.getModalidadesRequest({
          codigoContratante: newFilterParams.codigoContratante,
        })
      );
    }

    setCancelFilterExtendsOpen(true);
  }

  function setListaActionToDispatch(action, params) {
    if (action === 'cancelar') {
      return ListaActions.patchListaEnvioRPARequest(params, false);
    }

    return ListaActions.patchStatusRPARequest(params, action);
  }

  function handleAcaoListas(listas, tipoAcao) {
    if (listas.length > 0) {
      const params = listas.map((l) => {
        return { idLista: l.lista.idLista };
      });

      const actionLista = setListaActionToDispatch(tipoAcao, params);

      dispatch(actionLista);
    }
  }

  function handleAcaoListaById(listas, tipoAcao) {
    const params = [
      {
        idLista: listas,
      },
    ];
    const actionLista = setListaActionToDispatch(tipoAcao, params);

    dispatch(actionLista);
  }

  function setAcaoLista(listas, tipoAcao) {
    return Array.isArray(listas)
      ? handleAcaoListas(listas, tipoAcao)
      : handleAcaoListaById(listas, tipoAcao);
  }

  function handleDropdownItemClick(item) {
    let tipoRelatorio;
    if (item.includes('resumido')) {
      dispatch(
        ListaActions.getRelatorioRPARequest(relatorioRPAParams, 'resumido')
      );
      tipoRelatorio = 'resumido';
    } else if (item.includes('detalhado')) {
      dispatch(
        ListaActions.getRelatorioRPARequest(relatorioRPAParams, 'detalhado')
      );

      tipoRelatorio = 'detalhado';
    }

    const newLoading = produce(relatoriosLoading, (draft) => {
      draft[tipoRelatorio] = true;
    });

    setRelatoriosLoading(newLoading);
  }

  function handleConfirmAction(listas, tipoAcao) {
    const qtdListas = Array.isArray(listas) ? listas.length : 1;

    if (tipoAcao === 'cancelar') {
      modal.warning(
        <ModalCancelarEnvioRpa.BodyCancelarEnvioRpa qtdListas={qtdListas} />,
        () => {},
        ({ closeModal }) => (
          <ModalCancelarEnvioRpa.FooterCancelarEnvioRpa
            closeModal={closeModal}
            onClickOk={() => {
              setAcaoLista(listas, tipoAcao);
              closeModal();
            }}
          />
        )
      );
    } else {
      modal.warning(
        <ModalAlterarStatusRpa.BodyAlterarStatusRpa qtdListas={qtdListas} />,
        () => {},
        ({ closeModal }) => (
          <ModalAlterarStatusRpa.FooterAlterarStatusRpa
            closeModal={closeModal}
            onClickOk={() => {
              setAcaoLista(listas, tipoAcao);
              closeModal();
            }}
          />
        )
      );
    }
  }

  function getListasRPA() {
    const params = {
      ...paginationParams,
    };

    dispatch(
      ListaActions.getListasRPARequest(
        params,
        StatusListaRPAEnum.returnNameForTab
      )
    );
  }

  function handleModalSuccess() {
    setOpenModalSuccess({
      success: !openModalSuccess.success,
    });

    if (patchStatusRPA.success) {
      dispatch(ListaActions.patchStatusRPARenew());
    }
    if (patchListaEnvioRPA.success) {
      dispatch(ListaActions.patchListaEnvioRPARenew());
    }

    const newFilterParams = produce(queryParams, (draft) => {
      draft.movement_list_filter.status = status;
    });

    const params = {
      ...newFilterParams,
      ...paginationRequest,
    };

    dispatch(ListaActions.postSearchListRpaRequest(params));
    dispatch(ListaActions.getStatusListRpaRequest());
  }

  function downloadFile(base64, filename) {
    const temp = `data:application/vnd.ms-excel;base64,${encodeURIComponent(
      base64
    )}`;
    const download = document.createElement('a');
    download.href = temp;
    download.download = filename;
    document.body.appendChild(download);
    download.click();
    document.body.removeChild(download);
  }

  useEffect(() => {
    handleModalidadesTermos();
  }, []);

  useEffect(() => {
    if (patchStatusRPA.success) {
      setOpenModalSuccess({
        success: !openModalSuccess.success,
        message: 'Status alterado com sucesso.',
      });
    }
  }, [patchStatusRPA.success]);

  useEffect(() => {
    if (patchListaEnvioRPA.success) {
      setOpenModalSuccess({
        success: !openModalSuccess.success,
        message: 'Cancelamento de envio foi efetuado.',
      });
    }
  }, [patchListaEnvioRPA.success]);

  useEffect(() => {
    if (!getRelatorioRPA.loading && getRelatorioRPA.success) {
      if (getRelatorioRPA.response.fileContents !== '') {
        downloadFile(
          getRelatorioRPA.response.fileContents,
          getRelatorioRPA.response.fileDownloadName
        );
      }
    }

    if (!getRelatorioRPA.loading) {
      setRelatoriosLoading({ resumido: false, detalhado: false });
    }
  }, [getRelatorioRPA.loading, getRelatorioRPA.response]);

  return (
    <Container>
      <FadeIn>
        <WrapperFlex justifyStart alignStart column>
          <WrapperFlex fullWidth justifySpaceBetween alignStart>
            <Title
              text="listas de RPA"
              color={theme.titleGray}
              fontSize={38}
              marginBottom={8}
            />
            <WrapperFlex
              justifySpaceEvenly
              alignCenter
              marginSides={10}
              flexWrap
            >
              <Dropdown
                options={optionsButtonRPA}
                tipo="button"
                width={204}
                height={40}
                background={theme.greenDefault}
                fontHeader="16px unimed_slabregular"
              >
                <MdFileDownload size="20" color={theme.whiteDefault} />
                baixar relatório
              </Dropdown>
            </WrapperFlex>
          </WrapperFlex>
          <Breadcrumbs
            crumbs={[
              { path: 'novo' },
              {
                path: 'listas rpa',
                onNavigate: () => history.push('/novo/listas-rpa'),
              },
            ]}
          />
        </WrapperFlex>
        <StatusListRpa />

        {status.length < 1 ? (
          <WrapperFlex justifyStart alignStart row>
            <SearchBox
              onClick={handleFilterExtends}
              isPressed={openFilterExtends}
              placeholder="Pesquise por nome da lista"
              onChange={handleInputChange}
              value={inputValue}
              onKeyDown={handleInputKeyDown}
              cancelFilterExtendsOpen={cancelFilterExtendsOpen}
              IconFilter={MdFilterList}
              IconSearch={MdSearch}
            />
          </WrapperFlex>
        ) : (
          <Form onSubmit={handleSubmit}>
            <WrapperFlex justifyStart alignStart row>
              <SearchBox
                onClick={handleFilterExtends}
                isPressed={openFilterExtends}
                placeholder="Pesquise por nome da lista"
                onChange={handleInputChange}
                value={inputValue}
                onKeyDown={handleInputKeyDown}
                cancelFilterExtendsOpen={cancelFilterExtendsOpen}
                IconFilter={MdFilterList}
                IconSearch={MdSearch}
              >
                <WrapperFlex
                  marginTop={25}
                  justifyStart
                  alignStart
                  row
                  marginBottom={70}
                >
                  <FilterExtends
                    isOpen={openFilterExtends}
                    isGetModalidadesSuccess={success}
                    modalidades={response}
                    handleGetModalidadesByContratante={
                      handleGetModalidadesByContratante
                    }
                    setSearchBoxValue={setInputValue}
                    cleanFilterParams={cleanFilterParams}
                  />
                </WrapperFlex>
              </SearchBox>
            </WrapperFlex>
          </Form>
        )}

        <WrapperFlex marginTop={25} justifyStart alignCenter column>
          {status.length < 1 && !searchBoxActive ? (
            <Text
              size={20}
              bold
              text="Ao menos um status deve ser selecionado para iniciar a pesquisa"
            />
          ) : (
            <TabTableListasRPA
              setPaginationParams={setPaginationParams}
              paginationParams={paginationParams}
              handlePageChangeKeyDown={handlePageChangeKeyDown}
              handleConfirmAction={handleConfirmAction}
              dropdownOptions={StatusListaRPAEnum.returnNameFormatted}
              handleChangePage={handleChangePage}
              handleChangeTab={handleChangeTab}
            />
          )}
        </WrapperFlex>
      </FadeIn>
      <Modal
        tipo="success"
        onClick={handleModalSuccess}
        isOpen={openModalSuccess.message}
        footer={
          <>
            <Button
              tipo="primary"
              marginBottom={30}
              display="block"
              width={100}
              font="16px unimed_slabregular"
              onClick={handleModalSuccess}
            >
              ok
            </Button>
          </>
        }
      >
        <Text
          center
          text={openModalSuccess.message}
          font="300 14px work_sans"
          color={theme.titleGray}
        />
      </Modal>
    </Container>
  );
}

export default ListasRPA;
